import axios from 'axios';
import api from './api';
import { IDocumentsWithFiltersResponse, IActualAPIResponse, IDocumentsWithDocumentTypeFiltersResponse } from '@/context/data.types';

const { pimcoreServiceAPI } = api;

const GET_DOCUMENT_AND_CERTIFICATES_PATH = "/vendor/document/list";
const GET_DOCUMENT_AND_CERTIFICATES_DETAILS_PATH = "/vendor/document/details?vendorAssessmentId=";


const documentsCertificatesService = {
    getDocumentAndCertificates: async (): Promise<IDocumentsWithFiltersResponse> => {
        try {
            const resp = await pimcoreServiceAPI.get(GET_DOCUMENT_AND_CERTIFICATES_PATH);
            
            if (!resp || !resp.data) {
                return { 
                    vendorDocuments: [], 
                    total: 0, 
                    filters: { Product_Types: [], Vendor_Types: [], Document_Types: [] }
                };
            }

            // Handle the actual API response structure
            const apiResponse: IActualAPIResponse = resp.data;
            
            // Initialize filter arrays
            const transformedFilters = {
                Product_Types: [] as Array<{ id: string; name: string;  }>,
                Vendor_Types: [] as Array<{ id: string; name: string; }>,
                Document_Types: [] as Array<{ id: string; name: string;}>
            };

            // Process filter data from the response
            if (apiResponse.filters && Array.isArray(apiResponse.filters)) {
                apiResponse.filters.forEach((filterGroup) => {
                    // Process productType filters
                    if (filterGroup.productType && Array.isArray(filterGroup.productType) && filterGroup.productType.length > 0) {
                        transformedFilters.Product_Types = filterGroup.productType.map((item, index) => ({
                            id: `product_type_${index}`,
                            name: item.value,
                            count: 0 // Count not provided in API response, defaulting to 0
                        }));
                    }
                    
                    // Process vendorType filters
                    if (filterGroup.vendorType && Array.isArray(filterGroup.vendorType) && filterGroup.vendorType.length > 0) {
                        transformedFilters.Vendor_Types = filterGroup.vendorType.map((item, index) => ({
                            id: `vendor_type_${index}`,
                            name: item.value,
                            count: 0 // Count not provided in API response, defaulting to 0
                        }));
                    }
                });
            }
           

            console.log("transformedFilters", transformedFilters);
            // Return the transformed response with both documents and filters
            // return {
            //     vendorDocuments: apiResponse.vendorDocuments || [],
            //     total: apiResponse.total || 0,
            //     filters: transformedFilters
            // };

            const transformedVendorDocuments = (apiResponse.vendorDocuments || []).map(doc => ({
                ...doc,
                vendorType: doc.vendorType || "New"  // Set to "New" if null/empty
            }));
            
            return {
                vendorDocuments: transformedVendorDocuments,
                total: apiResponse.total || 0,
                filters: transformedFilters
            };

        } catch (error) {
            console.error("Error fetching documents and certificates data:", error);
            throw error;
        }
    },
    getDocumentDetails: async (vendorAssessmentId: string): Promise<any> => {
        try {
            const resp = await pimcoreServiceAPI.get(GET_DOCUMENT_AND_CERTIFICATES_DETAILS_PATH + vendorAssessmentId);
            return resp ? resp.data : { vendorDocuments: [], total: 0 };
        } catch (error) {
            console.error("Error fetching documents and certificates data:", error);
            throw error;
        }
    },

    getDocumentAndCertificateFilters: async (): Promise<IDocumentsWithDocumentTypeFiltersResponse> => {
        try {
            const resp = await pimcoreServiceAPI.get(GET_DOCUMENT_AND_CERTIFICATES_PATH);
            
            if (!resp || !resp.data) {
                return {
                    Product_Types: [],
                    Vendor_Types: [],
                    Document_Types: []
                };
            }

            // Handle the actual API response structure
            const apiResponse: IActualAPIResponse = resp.data;
            
            // Initialize filter arrays
            const transformedFilters = {
                Product_Types: [] as Array<{ id: string; name: string; }>,
                Vendor_Types: [] as Array<{ id: string; name: string; }>,
                Document_Types: [] as Array<{ id: string; name: string; }>
            };

            // Process filter data from the response
            if (apiResponse.filters && Array.isArray(apiResponse.filters)) {
                apiResponse.filters.forEach((filterGroup) => {
                    // Process productType filters
                    if (filterGroup.productType && Array.isArray(filterGroup.productType) && filterGroup.productType.length > 0) {
                        transformedFilters.Product_Types = filterGroup.productType.map((item, index) => ({
                            id: `product_type_${index}`,
                            name: item.value
                        }));
                    }
                    
                    // Process vendorType filters
                    if (filterGroup.vendorType && Array.isArray(filterGroup.vendorType) && filterGroup.vendorType.length > 0) {
                        transformedFilters.Vendor_Types = filterGroup.vendorType.map((item, index) => ({
                            id: `vendor_type_${index}`,
                            name: item.value
                        }));
                    }
                });
                transformedFilters.Document_Types = [{
                    id: `document_type_1`,
                    name: "Product Documents",
                },
                {
                    id: `document_type_2`,
                    name: "Vendor Documents",
                }]
            }
            console.log("transformedFilters", transformedFilters);
            return transformedFilters


        } catch (error) {
            console.error("Error fetching documents and certificates data:", error);
            throw error;
        }
    },
};

export default documentsCertificatesService;